import React, { useCallback } from 'react';
import HeaderSliderItem from './header-slider-item';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
SwiperCore.use([Autoplay]);
//
// スライド用の子要素を生成する
const createSliderItems = (saleItemList) => {
    return saleItemList.map((saleItem, index) => {
        return (React.createElement(SwiperSlide, { key: `${saleItem.image_name}${index}` },
            React.createElement(HeaderSliderItem, { saleItem: saleItem })));
    });
};
//
// Swiperの初期化
const initSwiper = (saleItemList, onSwiper) => {
    if (saleItemList.length === 0) {
        return null;
    }
    return (React.createElement(Swiper, { freeMode: true, allowTouchMove: false, loop: true, autoplay: { delay: 0 }, speed: 3000, slidesPerView: 'auto', onSwiper: onSwiper }, createSliderItems(saleItemList)));
};
const HeaderSlider = ({ saleItemList }) => {
    //
    // swiperの初期化完了
    const onSwiper = useCallback((swiper) => {
        // スライド時のイージング処理を上書きする
        swiper.$wrapperEl[0].style.transitionTimingFunction = 'linear';
    }, []);
    return (React.createElement("div", { className: 'header-slider-navbox' }, initSwiper(saleItemList, onSwiper)));
};
export default HeaderSlider;
